
export function handleResponse(response) {
   
    return response.text().then(text => {
        var  data;
        if(text)
         try{
            data = JSON.parse(text);
         }
         catch(err)
         {
            console.log("Invalid JSON");
         }
        if (!response.ok) {
            if ([401, 403].indexOf(response.status) !== -1) {
                // auto logout if 401 Unauthorized or 403 Forbidden response returned from api
            //    authenticationService.logout();
            //    window.location.reload(true);
            }
            
            var  error = (data && data.message);

            if(!error)
            {
                if(!response.statusText || response.statusText==='')
                    error = "Server Communications Error: " +response.status;
                else
                
                    error = response.statusText;
            }
            
            return Promise.reject(error);
        }

        return data;
    });
}